import React, { useContext, useEffect } from 'react';
import { Formik } from 'formik';
import * as Yup from 'yup';
import {
  TextField,
  FormHelperText,
  Button,
  MenuItem,
  FormControl,
  InputLabel,
  Select,
  FormControlLabel,
  Checkbox,
  Typography,
} from '@material-ui/core';
import { ThemeContext } from '../../../themes/ThemeProvider';
import { useDispatch, useSelector } from 'react-redux';
import {
  postContactsData,
  resetToast,
} from '../../../redux/reducers/clientMangement/Organizaation';
import GuiTextField from '../../../components/FormComponents/GuiTextField';
import GuiAutoComplete from '../../../components/FormComponents/GuiAutoComplete';
import { PhoneMaskCustom } from '../../../util/PhoneMaskFormat';
import { STATE } from '../../../constants/Lookup';
import { getOptions } from '../../../util/GetDropDownOptions';
import formatPhoneNumber from '../../../util/PhoneFormat';
import { submissionStart } from '../../../redux/reducers/CommonActions/commonActions';

const CompanyForm = ({ setOpen = () => {}, id, orgType, selectedRows, type }) => {
  const { reusableInputStyles } = useContext(ThemeContext);
  const classes = reusableInputStyles();
  const dispatch = useDispatch();

  const { successMsg, errorMsg, dropDownData, editContactData, editAddressData } = useSelector(
    ({ organization }) => organization,
  );
  const { enabledSubmission } = useSelector(({ commonActions }) => commonActions);
  useEffect(() => {
    if (successMsg || errorMsg) {
      setTimeout(() => {
        dispatch(resetToast());
      }, 3000);
    }
  }, [successMsg, errorMsg]);

  const validationSchema = Yup.object().shape({
    contactType: Yup.mixed()
      .test('contactType', 'Contact Type is required', (value) => {
        if (!value?.value) {
          return false;
        } else {
          return true;
        }
      })
      .required('Contact Type is required'),
    firstName: Yup.string().required('First Name is required'),
    lastName: Yup.string().required('Last Name is required'),
    // title: Yup.string().required("Title is required"),
    emailAddress: Yup.string()
      .email('Invalid email format')
      .test('emailAddress', 'Email Address is required', (value, valid) => {
        const value1 = valid?.parent;
        if (!value && value1?.emailOptIn === 'Yes') {
          return false;
        } else {
          return true;
        }
      }),
    phoneNumber: Yup.string().test('phone', 'Invalid Phone Number', (value) => {
      value = value && value.replace(/[^\d]/g, '');
      if ((value && /^(\d)(?!\1+$)\d{9}$/.test(value)) || !value) {
        return true;
      }
    }),
  });
  const getOption = (data, property, value) => {
    if (!data || data?.length === 0) {
      return {};
    }
    const obj = data?.find((item) => item[property] === value);
    return obj ? obj : {};
  };
  const initialVal = {
    contactType: getOption(dropDownData?.CONTACT_TYPE, 'value', editContactData?.contactType) || {},
    firstName: editContactData?.firstName || '',
    lastName: editContactData?.lastName || '',
    title: editContactData?.title || '',
    emailAddress: editContactData?.emailAddress || '',
    emailOptIn: editContactData?.emailOptIn || 'Yes',
    isActive: editContactData?.isActive !== 'N',
    organizationContactId: 0,
    organizationId: 0,
    organizationType: '',
    //  phone initial values
    phoneType:
      getOption(dropDownData?.CLIENT_PHONE_TYPE, 'value', editContactData?.phoneType) || {},
    optInFlag: editContactData?.optInFlag || '',
    orgId: 0,
    orgPhoneId: 0,
    orgType: '',
    phoneNumber: formatPhoneNumber(editContactData?.phoneNumber) || '',
    seqNo: 0,
    // address intial values
    address1: editContactData?.address1 || '',
    address2: editContactData?.address2 || '',
    addressType:
      getOption(dropDownData?.CLIENT_ADDRESS_TYPE, 'value', editContactData?.addressType) || {},
    city: editContactData?.city || '',
    country: editContactData?.country || 'USA-United States of America',
    locationCode: editContactData?.locationCode || '',
    optInFlags: editContactData?.addressOptIn || 'Yes',
    orgAddressId: 0,
    // orgId: id,
    // orgType: type,
    state: getOption(dropDownData?.STATE, 'value', editContactData?.state) || {},
    zip: editContactData?.zip || '',
    addressFlag: getOption(dropDownData?.ADDRESS_FLAG, 'value', editContactData?.addressFlag) || {},
  };
  const handleSubmit = (values) => {
    if (values) {
      dispatch(submissionStart());
      const data = {
        contactType: values?.contactType?.value || '',
        emailAddress: values?.emailAddress || '',
        emailOptIn: values?.emailOptIn || 'Yes',
        firstName: values?.firstName || '',
        lastName: values?.lastName || '',
        title: values?.title || '',
        organizationContactId: editContactData?.organizationContactId || 0,
        organizationId: id,
        organizationType: orgType || '',
        isActive: values?.isActive === true ? 'Y' : 'N',
        sequenceNo: editContactData?.sequenceNo
          ? editContactData?.sequenceNo
          : Array.isArray(selectedRows)
            ? selectedRows?.length + 1
            : 1,
        optInFlag: values?.optInFlag || 'Yes',
        phoneNumber: values?.phoneNumber || '',
        phoneType: values?.phoneType?.value || '',
        address1: values?.address1 || '',
        address2: values?.address2 || '',
        addressType: values?.addressType?.value || '',
        city: values?.city || '',
        country: values?.country || '',
        locationCode: values?.locationCode || '',
        orgAddressId: editAddressData?.orgAddressId || 0,
        orgId: id,
        orgType: orgType || '',
        state: values?.state?.value || '',
        zip: values?.zip || '',
        addressFlag: values?.addressFlag?.value || '',
        addressOptIn: values?.optInFlags || '',
        // orgPhoneId: editContactPhoneData?.orgPhoneId || 0,
        // orgId: id,
        // orgType: orgType || "",
      };
      dispatch(postContactsData(data));
    }
  };
  return (
    <>
      <Formik
        onSubmit={(values) => handleSubmit(values)}
        initialValues={initialVal}
        validationSchema={validationSchema}
        enableReinitialize
      >
        {(props) => {
          const {
            values,
            errors,
            touched,
            handleBlur,
            handleSubmit,
            setFieldValue,
            resetForm,
            handleChange,
          } = props;
          return (
            <div className={classes.dialoguecardStyles}>
              <form autoComplete="off" noValidate onSubmit={handleSubmit}>
                <div className={`col-12 mt-3  ${classes.cardWrapper}`}>
                  <Typography className="sort-by ml-2">Contact Details</Typography>
                  <div className="form-row mt-3 global-field-textfields new-standard-textfields">
                    <div className="col-sm-8 col-md-6 col-lg-4 col-xl-4 form-group">
                      <GuiAutoComplete
                        classes={{
                          option: classes.option,
                        }}
                        id="contactType"
                        className={'errorcontent'}
                        options={dropDownData?.CONTACT_TYPE || []}
                        size="small"
                        value={values.contactType}
                        autoHighlight
                        getOptionLabel={(option) => {
                          return option && option.value ? option.value : '';
                        }}
                        renderInput={(params) => (
                          <GuiTextField
                            className={`${classes.labelName}`}
                            {...params}
                            variant="outlined"
                            fullWidth
                            label="Contact Type"
                            name="contactType"
                            // InputLabelProps={{
                            //   shrink: true,
                            // }}
                            required
                            placeholder="Select Contact Type"
                            inputProps={{
                              ...params.inputProps,
                              autoComplete: 'off',
                            }}
                            touched={touched.contactType}
                            error={touched.contactType && errors.contactType}
                          />
                        )}
                        onChange={(_, data) => {
                          setFieldValue('contactType', data);
                        }}
                      />
                      <FormHelperText style={{ color: 'red' }}>
                        {touched.contactType && errors?.contactType && errors.contactType}
                      </FormHelperText>
                    </div>
                    <div className="col-sm-8 col-md-6 col-lg-4 col-xl-4 form-group">
                      <TextField
                        className={`${classes.labelName}`}
                        margin="dense"
                        variant="outlined"
                        placeholder={`Enter First Name`}
                        label="First Name"
                        // InputLabelProps={{
                        //   shrink: true,
                        // }}
                        name="firstName"
                        required
                        value={values?.firstName}
                        onChange={(e) => {
                          setFieldValue('firstName', e.target.value);
                        }}
                        onBlur={handleBlur}
                        fullWidth
                        touched={touched.firstName}
                        error={Boolean(touched.firstName && errors.firstName)}
                      />
                      <FormHelperText>
                        {touched.firstName && errors?.firstName && errors.firstName}
                      </FormHelperText>
                    </div>
                    <div className="col-sm-8 col-md-6 col-lg-4 col-xl-4 form-group">
                      <TextField
                        className={`${classes.labelName}`}
                        margin="dense"
                        variant="outlined"
                        placeholder={`Enter Last Name`}
                        label="Last Name"
                        // InputLabelProps={{
                        //   shrink: true,
                        // }}
                        name="lastName"
                        required
                        value={values?.lastName}
                        onChange={(e) => {
                          setFieldValue('lastName', e.target.value);
                        }}
                        onBlur={handleBlur}
                        fullWidth
                        touched={touched.lastName}
                        error={Boolean(touched.lastName && errors.lastName)}
                      />
                      <FormHelperText>
                        {touched.lastName && errors?.lastName && errors.lastName}
                      </FormHelperText>
                    </div>
                    <div className="col-sm-8 col-md-6 col-lg-4 col-xl-4 form-group">
                      <TextField
                        className={`${classes.labelName}`}
                        margin="dense"
                        variant="outlined"
                        placeholder={`Enter Title`}
                        label="Title"
                        // InputLabelProps={{
                        //   shrink: true,
                        // }}
                        name="title"
                        value={values?.title}
                        onChange={(e) => {
                          setFieldValue('title', e.target.value);
                        }}
                        onBlur={handleBlur}
                        fullWidth
                        // touched={touched.title}
                        // error={Boolean(touched.title && errors.title)}
                      />
                    </div>
                    <div className="col-sm-8 col-md-6 col-lg-4 col-xl-4 form-group">
                      <TextField
                        className={`${classes.labelName}`}
                        margin="dense"
                        variant="outlined"
                        placeholder={`Enter Email Address`}
                        label="Email Address"
                        // InputLabelProps={{
                        //   shrink: true,
                        // }}
                        name="emailAddress"
                        required={values?.emailOptIn === 'Yes'}
                        value={values?.emailAddress}
                        onChange={(e) => {
                          setFieldValue('emailAddress', e.target.value);
                        }}
                        onBlur={handleBlur}
                        fullWidth
                        touched={touched.emailAddress}
                        error={Boolean(touched.emailAddress && errors.emailAddress)}
                      />
                      <FormHelperText>
                        {touched.emailAddress && errors?.emailAddress && errors.emailAddress}
                      </FormHelperText>
                    </div>

                    <div
                      className={`col-sm-8 col-md-6 col-lg-4 col-xl-4 form-group ${classes.selectField}`}
                    >
                      <FormControl
                        // margin="dense"
                        variant="outlined"
                        fullWidth
                      >
                        <InputLabel id="demo-simple-select-label">Email Opt In</InputLabel>
                        <Select
                          fullWidth
                          id="demo-simple-select"
                          className={`${classes.labelName}`}
                          labelId="demo-simple-select-label"
                          name="emailOptIn"
                          label="Email Opt In"
                          value={values.emailOptIn || 'Yes'}
                          onChange={(e) => {
                            setFieldValue('emailOptIn', e.target.value);
                          }}
                        >
                          {['Yes', 'No'].map((option) => {
                            return (
                              <MenuItem value={option} key={option}>
                                {option}
                              </MenuItem>
                            );
                          })}
                        </Select>
                      </FormControl>
                    </div>
                    {/* <div
                    className={`col-sm-8 col-md-6 col-xl-4 form-group ${classes.labelName} ${classes.selectdropdown}`}
                  >
                    <FormControl
                      margin="dense"
                      variant="outlined"
                      fullWidth
                      className="form-control"
                    >
                      <InputLabel className={classes.selectLabel}>Status</InputLabel>
                      <Select
                        fullWidth
                        name="isActive"
                        label="Status"
                        value={values.isActive}
                        onChange={(e) => {
                          setFieldValue("isActive", e.target.value);
                        }}
                      >
                        {["Yes", "No"].map((option) => {
                          return (
                            <MenuItem value={option} key={option}>
                              {option}
                            </MenuItem>
                          );
                        })}
                      </Select>
                    </FormControl>
                  </div> */}
                    <div className="col-sm-8 col-md-6 col-lg-4 col-xl-4">
                      <FormControl margin="dense">
                        <FormControlLabel
                          className={`m-0 &{classes.checkRoot}`}
                          control={
                            <Checkbox
                              onChange={handleChange}
                              name="isActive"
                              checked={values.isActive}
                            />
                          }
                          label="Is Active"
                          labelPlacement="end"
                        />
                      </FormControl>
                    </div>
                  </div>
                </div>

                <div className={`col-12 mt-3 ${classes.cardWrapper}`}>
                  <Typography className="sort-by ml-2">Phone Details</Typography>
                  <div className="form-row mt-3 global-field-textfields new-standard-textfields">
                    <div className="col-sm-8 col-md-6 col-lg-4 col-xl-4 form-group">
                      <TextField
                        className={`${classes.labelName}`}
                        margin="dense"
                        variant="outlined"
                        placeholder={`Enter Phone Number`}
                        label="Phone Number"
                        // InputLabelProps={{
                        //   shrink: true,
                        // }}
                        name="phoneNumber"
                        value={values?.phoneNumber}
                        onChange={(e) => {
                          handleChange(e);
                          setFieldValue('phoneNumber', e.target.value);
                        }}
                        onBlur={handleBlur}
                        InputProps={{
                          inputComponent: PhoneMaskCustom,
                        }}
                        fullWidth
                        touched={touched.phoneNumber}
                        error={Boolean(touched.phoneNumber && errors.phoneNumber)}
                      />
                      <FormHelperText style={{ color: 'red' }}>
                        {touched.phoneNumber && errors?.phoneNumber && errors.phoneNumber}
                      </FormHelperText>
                    </div>
                    <div className="col-sm-8 col-md-6 col-lg-4 col-xl-4 form-group">
                      <GuiAutoComplete
                        classes={{
                          option: classes.option,
                        }}
                        id="phoneType"
                        options={dropDownData?.CLIENT_PHONE_TYPE || []}
                        size="small"
                        value={values.phoneType}
                        autoHighlight
                        getOptionLabel={(option) => {
                          return option && option.valueCode && option.value
                            ? option.valueCode + ' - ' + option.value
                            : option.value === null
                              ? option.valueCode
                              : '';
                        }}
                        renderInput={(params) => (
                          <GuiTextField
                            className={`${classes.labelName}`}
                            {...params}
                            variant="outlined"
                            fullWidth
                            label="Phone Type"
                            name="phoneType"
                            // InputLabelProps={{
                            //   shrink: true,
                            // }}
                            placeholder="Select Phone Type"
                            inputProps={{
                              ...params.inputProps,
                              autoComplete: 'off',
                            }}
                            touched={touched.phoneType}
                            error={touched.phoneType && errors.phoneType}
                          />
                        )}
                        onChange={(_, data) => {
                          setFieldValue('phoneType', data);
                        }}
                      />
                      <FormHelperText style={{ color: 'red' }}>
                        {touched.phoneType && errors?.phoneType && errors.phoneType}
                      </FormHelperText>
                    </div>
                    <div
                      className={`col-sm-8 col-md-6 col-lg-4 col-xl-4 form-group ${classes.selectField}`}
                    >
                      <FormControl
                        // margin="dense"
                        variant="outlined"
                        fullWidth
                        className="form-control"
                      >
                        <InputLabel className={classes.selectLabel}>Opt In</InputLabel>
                        <Select
                          fullWidth
                          name="optInFlag"
                          label="Opt In"
                          value={values.optInFlag || 'Yes'}
                          onChange={(e) => {
                            setFieldValue('optInFlag', e.target.value);
                          }}
                        >
                          {['Yes', 'No'].map((option) => {
                            return (
                              <MenuItem value={option} key={option}>
                                {option}
                              </MenuItem>
                            );
                          })}
                        </Select>
                      </FormControl>
                    </div>
                  </div>
                </div>

                <div className={`col-12 mt-3 ${classes.cardWrapper}`}>
                  <Typography className="sort-by ml-2">Address Details</Typography>
                  <div className="form-row mt-3 global-field-textfields new-standard-textfields">
                    <div className="col-sm-8 col-md-6 col-lg-4 col-xl-4 form-group">
                      <GuiAutoComplete
                        classes={{
                          option: classes.option,
                        }}
                        id="addressType"
                        options={dropDownData?.CLIENT_ADDRESS_TYPE || []}
                        size="small"
                        value={values.addressType}
                        autoHighlight
                        getOptionLabel={(option) => {
                          return option && option.valueCode && option.value
                            ? option.valueCode + ' - ' + option.value
                            : option.value === null
                              ? option.valueCode
                              : '';
                        }}
                        renderInput={(params) => (
                          <GuiTextField
                            className={`${classes.labelName}`}
                            {...params}
                            variant="outlined"
                            fullWidth
                            label="Address Type"
                            name="addressType"
                            // InputLabelProps={{
                            //   shrink: true,
                            // }}
                            touched={touched.addressType}
                            error={touched.addressType && errors.addressType}
                            placeholder="Select Address Type"
                            inputProps={{
                              ...params.inputProps,
                              autoComplete: 'off', // disable autocomplete and autofill
                            }}
                          />
                        )}
                        onChange={(_, data) => {
                          setFieldValue('addressType', data);
                        }}
                      />
                      <FormHelperText style={{ color: 'red' }}>
                        {touched.addressType && errors?.addressType && errors.addressType}
                      </FormHelperText>
                    </div>
                    <div className="col-sm-8 col-md-6 col-lg-4 col-xl-4 form-group">
                      <TextField
                        className={`${classes.labelName}`}
                        placeholder="Enter Address Line 1"
                        margin="dense"
                        name="address1"
                        variant="outlined"
                        value={values.address1}
                        onChange={handleChange}
                        label="Address Line 1"
                        // InputLabelProps={{
                        //   shrink: true,
                        // }}
                        fullWidth
                        touched={touched.address2}
                        error={touched.address1 && errors.address1}
                      />
                      <FormHelperText variant="outlined">
                        {touched.address1 && errors?.address1 && errors.address1}
                      </FormHelperText>
                    </div>
                    <div className="col-sm-8 col-md-6 col-lg-4 col-xl-4 form-group">
                      <TextField
                        className={`${classes.labelName}`}
                        placeholder="Enter Address Line 2"
                        margin="dense"
                        name="address2"
                        variant="outlined"
                        value={values.address2}
                        onChange={handleChange}
                        label="Address Line 2"
                        // InputLabelProps={{
                        //   shrink: true,
                        // }}
                        fullWidth
                        touched={touched.address2}
                        error={touched.address2 && errors.address2}
                      />
                      <FormHelperText variant="outlined">
                        {touched.address2 && errors?.address2 && errors.address2}
                      </FormHelperText>
                    </div>
                    <div className="col-sm-8 col-md-6 col-lg-4 col-xl-4 form-group">
                      <TextField
                        className={`${classes.labelName}`}
                        placeholder="Enter City"
                        margin="dense"
                        name="city"
                        variant="outlined"
                        label="City"
                        // InputLabelProps={{
                        //   shrink: true,
                        // }}
                        value={values.city}
                        onChange={handleChange}
                        fullWidth
                        touched={touched.city}
                        error={touched.city && errors.city}
                      />
                      <FormHelperText variant="outlined">
                        {touched.city && errors?.city && errors.city}
                      </FormHelperText>
                    </div>
                    <div className="col-sm-8 col-md-6 col-lg-4 col-xl-4 form-group">
                      <GuiAutoComplete
                        classes={{
                          option: classes.option,
                        }}
                        id="state"
                        options={getOptions(STATE, dropDownData)}
                        size="small"
                        value={values.state}
                        autoHighlight
                        getOptionLabel={(option) => {
                          return option && option.valueCode && option.value
                            ? option.valueCode + ' - ' + option.value
                            : option.value === null
                              ? option.valueCode
                              : '';
                        }}
                        renderInput={(params) => (
                          <GuiTextField
                            className={`${classes.labelName}`}
                            {...params}
                            variant="outlined"
                            fullWidth
                            label="State"
                            name="state"
                            // InputLabelProps={{
                            //   shrink: true,
                            // }}
                            placeholder="Select State"
                            inputProps={{
                              ...params.inputProps,
                              autoComplete: 'off', // disable autocomplete and autofill
                            }}
                            touched={touched.state}
                            error={touched.state && errors.state}
                          />
                        )}
                        onChange={(_, data) => {
                          setFieldValue('state', data);
                        }}
                      />
                      <FormHelperText style={{ color: 'red' }}>
                        {touched.state && errors?.state && errors.state}
                      </FormHelperText>
                    </div>
                    <div className="col-sm-8 col-md-6 col-lg-4 col-xl-4 form-group">
                      <TextField
                        className={`${classes.labelName}`}
                        placeholder="Enter Zip Code"
                        margin="dense"
                        name="zip"
                        variant="outlined"
                        label="Zip Code"
                        // InputLabelProps={{
                        //   shrink: true,
                        // }}
                        value={values.zip}
                        onChange={handleChange}
                        fullWidth
                        touched={touched.zip}
                        error={touched.zip && errors.zip}
                      />
                      <FormHelperText variant="outlined">
                        {touched.zip && errors?.zip && errors.zip}
                      </FormHelperText>
                    </div>
                    <div className="col-sm-8 col-md-6 col-lg-4 col-xl-4 form-group">
                      <TextField
                        className={`${classes.labelName}`}
                        placeholder="Enter Country"
                        margin="dense"
                        name="country"
                        variant="outlined"
                        label="Country"
                        // InputLabelProps={{
                        //   shrink: true,
                        // }}
                        value={values.country}
                        onChange={handleChange}
                        fullWidth
                        error={errors && errors.country}
                      />
                      <FormHelperText variant="outlined">
                        {errors?.country ? errors.country : ''}
                      </FormHelperText>
                    </div>
                    <div className="col-sm-8 col-md-6 col-lg-4 col-xl-4 form-group">
                      <TextField
                        className={`${classes.labelName}`}
                        placeholder="Enter Location Code"
                        margin="dense"
                        name="locationCode"
                        variant="outlined"
                        label="Location Code"
                        // InputLabelProps={{
                        //   shrink: true,
                        // }}
                        value={values.locationCode}
                        onChange={handleChange}
                        fullWidth
                      />
                    </div>
                    <div
                      className={`col-sm-8 col-md-6 col-lg-4 col-xl-4 form-group ${classes.selectField}`}
                    >
                      <FormControl
                        // margin="dense"
                        variant="outlined"
                        fullWidth
                        className="form-control"
                      >
                        <InputLabel className={classes.selectLabel}>Opt In</InputLabel>
                        <Select
                          fullWidth
                          name="optInFlags"
                          className={`${classes.labelName}`}
                          label="Opt In"
                          value={values.optInFlags || 'Yes'}
                          onChange={(e) => {
                            setFieldValue('optInFlags', e.target.value);
                          }}
                        >
                          {['Yes', 'No'].map((option) => {
                            return (
                              <MenuItem value={option} key={option}>
                                {option}
                              </MenuItem>
                            );
                          })}
                        </Select>
                      </FormControl>
                    </div>
                    <div className="col-sm-8 col-md-6 col-lg-4 col-xl-4 form-group">
                      <GuiAutoComplete
                        classes={{
                          option: classes.option,
                        }}
                        id="addressFlag"
                        options={dropDownData?.ADDRESS_FLAG || []}
                        size="small"
                        value={values.addressFlag}
                        autoHighlight
                        getOptionLabel={(option) => {
                          return option && option.valueCode && option.value
                            ? option.valueCode + ' - ' + option.value
                            : option.value === null
                              ? option.valueCode
                              : '';
                        }}
                        renderInput={(params) => (
                          <GuiTextField
                            className={`${classes.labelName}`}
                            {...params}
                            variant="outlined"
                            fullWidth
                            label="Address Flag"
                            name="addressFlag"
                            InputLabelProps={{
                              shrink: true,
                            }}
                            placeholder="Select Address Flag"
                            inputProps={{
                              ...params.inputProps,
                              autoComplete: 'off',
                            }}
                            touched={touched.addressFlag}
                            error={touched.addressFlag && errors.addressFlag}
                          />
                        )}
                        onChange={(_, data) => {
                          setFieldValue('addressFlag', data);
                        }}
                      />
                      <FormHelperText style={{ color: 'red' }}>
                        {touched.addressFlag && errors?.addressFlag && errors.addressFlag}
                      </FormHelperText>
                    </div>
                  </div>
                </div>
                <div className="d-flex justify-content-center align-items-center new-standard-textfields mt-3">
                  <Button
                    variant="outlined"
                    className={`reset-btn mr-1 ${classes.buttonRoot}`}
                    onClick={() => {
                      resetForm();
                    }}
                  >
                    Reset
                  </Button>
                  <Button
                    variant="outlined"
                    type="submit"
                    disabled={enabledSubmission}
                    className={`search-btn ml-1 mr-1 ${classes.buttonRoot}`}
                  >
                    Save
                  </Button>
                </div>
              </form>
            </div>
          );
        }}
      </Formik>
    </>
  );
};

export default CompanyForm;
